import { Heading, Paragraph } from "@/components/ui/Typography";
import { Button } from "@/components/ui";

import micrositeTemplatesData from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/micrositeTemplateTypesData";
import TemplatePreviewCard from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/TemplatePreviewCard";
import { useState } from "react";
import { IProgrammeMultiStepFormValues } from "@/pages/articles-pages/programmes/MultiStepForm/MultiStepForm";

interface MicroSiteTemplatesListProps {
  prevStep?: () => void;
    nextStep: () => void;
    handleFormData: (data: IProgrammeMultiStepFormValues) => void;
    formValues: IProgrammeMultiStepFormValues;
}

const MicroSiteTemplatesList = ({ nextStep, prevStep, handleFormData, formValues }: MicroSiteTemplatesListProps) => {
 
  const [selectedTemplate, setSelectedTemplate] = useState<string>(formValues.microSiteRequest?.micrositeTemplateType || "");


  return (
      <div className="bg-white rounded-xl flex flex-col h-full w-full">               
              <div className="flex flex-col  justify-center p-4 h-full gap-8">
                <div className="flex flex-col gap-1 lg:w-3/4 mx-auto">
                    <Heading level={4}>Microsites</Heading>
                <Paragraph>Select and modify any of the following template </Paragraph>
                </div>
    
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full lg:w-3/4 mx-auto lg:gap-12">
                  {micrositeTemplatesData.map((template) => (
                    <div
                      key={template.id}
                      onClick={() => setSelectedTemplate(template.id)}
                      className={`cursor-pointer rounded-xl p-2 hover:ring-2 hover:ring-[#047857] ${selectedTemplate === template.id ? 'ring-2 ring-[#047857]' : ''}`}
                    >
                      <TemplatePreviewCard template={template} readOnly />
                    </div>
                  ))}
                </div>

                <div className="mx-auto flex w-full max-w-5xl items-center justify-between border-t border-gray-200 pt-4">
                  <Button type="button" variant="secondary" onClick={prevStep}>
                    Back to Main Form
                  </Button>
                  <Button
                    type="button"
                    onClick={() => {
                      nextStep();
                        handleFormData({ ...formValues, microSiteRequest: { ...formValues.microSiteRequest, micrositeTemplateType: selectedTemplate } });
                      
                    }}
                    disabled={!selectedTemplate}
                  >
                    Continue to Microsite Preview
                  </Button>
                </div>
              
              </div>
              </div>
  )
}

export default MicroSiteTemplatesList